





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) private isDisabled: boolean | undefined
  @Prop({}) private funcFilter: any | undefined
  @Prop({}) private funcClearFilter: any | undefined
  @Prop({}) private hasFilter: boolean | undefined
  @Prop({}) private onClearFilter: boolean | undefined

  @Watch('onClearFilter')
  public changeHasFilter(value: boolean, oldValue: boolean) {
    this.team = ''
    this.salesman = ''
    this.position = ''
    this.byPosition3 = []
    this.typeSales = ''
    this.category = ''
    this.categoryId = ''
    this.filterDate = []
  }

  // enable button filter
  public get enableButtonFilter() {
    if (
      this.teamOptions.length === 0 &&
      this.byPosition3.length === 0 &&
      this.salesman.length === 0 &&
      this.typeSales.length === 0 &&
      this.category.length === 0 &&
      this.filterDate.length === 0
    ) {
      return true
    } else {
      return false
    }
  }

  // Search
  public text: string = ''
  private resetSearch() {
    this.salesman = ''
  }

  public salesman: string = ''
  public salesmanCode(text) {
    const salesCode = this.salesmansCode.find((e) => e.sales_code === text)
    const index = this.salesmansCode.indexOf(salesCode)
    if (text.length > 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getSalesman()
    }
  }
  public salesmansCode: any = []
  public get salesmanCodeData(): any {
    this.salesmansCode = MasterModule.SalesmanData.data
    return MasterModule.SalesmanData
  }

  // FIlter By Position
  public byPosition3: any = []
  public byPosition2: string = ''
  public byPosition: string = ''
  public position: string = ''
  public positionId: string = ''
  @Watch('byPosition3')
  public onPosition2Changed(value: string, oldValue: string) {
    this.byPosition = this.byPosition3.toString()
  }
  // @Watch('byPosition')
  // public onPositionChanged(value: string, oldValue: string) {
  //   if (this.byPosition.length >= 3) {
  //     MasterModule.paginationParam.search = this.byPosition
  //     MasterModule.getPosition()
  //   }
  // }
  public positions: any = []
  public get positionData() {
    this.positions = MasterModule.PositionData.data
    return MasterModule.PositionData
  }
  public onRemovePosition(data) {
    const index = this.byPosition3.indexOf(data)
    this.byPosition3.splice(index, 1)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
  }

  public onOptionClickPosition(data) {
    this.byPosition3.push(data)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    // console.log('By position')
    // console.log(this.byPosition)
    this.byPosition2 = ''
  }

  // filter by category
  public category: string = ''
  public categoryId: string = ''
  public byCategory(text) {
    // const find = this.categoryOptions.find((e) => e.name === text)
    // const index = this.categoryOptions.indexOf(find)
    if (text.length >= 3) {
      MasterCarStateDataModule.paginationParam.search = text
      MasterCarStateDataModule.getMasterCarData()
    }
    // if (this.categoryOptions.length >= 0) {
    //   this.categoryId = this.categoryOptions.find(
    //     (e) => e.name === text
    //   ).id
    // }
  }
  public categoryOptions: any = []
  public get categoryCode() {
    this.categoryOptions = MasterCarStateDataModule.masterCarData.data
    return MasterCarStateDataModule.masterCarData
  }
  public filterDate = []

  public typeSales: string = ''
  public items: any = [
    'Salesman',
    'Salesman Counter',
    'Branch Manager',
    'Sales Manager',
    'Supervisor',
  ]

  public team: string = ''
  public teamOptions: any = [
    {
      value: '',
      text: 'Team Category',
    },
    {
      value: 'PC',
      text: 'PC',
    },
    {
      value: 'LCV',
      text: 'LCV',
    },
  ]
}
